import { Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import MainEquipment from "../MainEquipment/MainEquipment";
import SubEquipment from "../SubEquipment/SubEquipment";

export default function EquipmentSelectionPopup(props) {
    const { t } = useTranslation("translation");

    const [isConfirmDisabled, setIsConfirmDisabled] = useState(false);

    useEffect(() => {
        if (!props.isAreaNotFiltered) return;
        if (props.selectedMainEquipmentCode === null && props.selectedSubEquipmentCode === null) {
            setIsConfirmDisabled(true);
        } else {
            setIsConfirmDisabled(false);
        }
    }, [props.selectedAreaCode, props.selectedMainEquipmentCode, props.selectedSubEquipmentCode]);

    return (
        <div>
            {props.areaDataLoaded === true ? (
                <Container>
                    <Dialog open={props.machineOpen} onClose={null} fullWidth="xs">
                        <div id="esp_MachinePopUpHead">
                            <DialogTitle>{t("SelectMachine")}</DialogTitle>
                        </div>
                        <DialogContent>
                            <form>
                                <FormControl variant="outlined" style={{ width: "100%" }}>
                                    <Autocomplete
                                        id="esp_Area"
                                        value={props.selectedAreaName ?? ""}
                                        onChange={(_event, newValue) => {
                                            props.handleAreaChange(newValue);
                                        }}
                                        options={props.areaData.map((option) => option.name)}
                                        renderInput={(params) => <TextField required={props.isRequired} {...params} margin="normal" label={t("Area")} variant="outlined" />}
                                    />
                                </FormControl>
                                <FormControl variant="outlined" style={{ width: "100%" }}>
                                    <MainEquipment
                                        isRequired={props.isRequired}
                                        handleMainEquipmentChange={props.handleMainEquipmentChange}
                                        selectedMainEquipmentName={props.selectedMainEquipmentName}
                                        mainEquipmentData={props.mainEquipmentData}
                                    />
                                </FormControl>
                                <FormControl variant="outlined" style={{ width: "100%" }}>
                                    <SubEquipment
                                        handleSubEquipmentChange={props.handleSubEquipmentChange}
                                        selectedSubEquipmentName={props.selectedSubEquipmentName}
                                        subEquipmentData={props.subEquipmentData}
                                    />
                                </FormControl>
                            </form>
                        </DialogContent>
                        <DialogActions>
                            <Button id="esp_Clean" onClick={props.handleMachineCancel} color="secondary">
                                {t("Clean")}
                            </Button>
                            <Button id="esp_Confirm" onClick={props.handleMachineClose} color="primary" disabled={isConfirmDisabled}>
                                {t("Confirm")}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Container>
            ) : null}
        </div>
    );
}
